import { Ruler } from "lucide-react";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { PolicyField } from "./PolicyField";
import type { PolicyCardProps } from "./policy-card.types";

// Spec 079 — a RÉGUA DO GÊMEO: quando o histórico de acerto passa a valer, e o que ele afirma.
export function TrackRecordPolicyCard({ register, errors, disabled }: PolicyCardProps) {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <Ruler className="h-4 w-4 text-text-tertiary" aria-hidden />
          Régua do gêmeo
        </CardTitle>
      </CardHeader>
      <CardContent className="grid gap-4 sm:grid-cols-3">
        <PolicyField
          id="policy-min-sample"
          label="Amostra mínima"
          unit="compromissos"
          hint="Abaixo disso o histórico não é usado, e a confiança volta a ser julgada pela origem dos dados. Amostra pequena decidindo a confiança é temerária, não conservadora."
          registration={register("trackRecordMinSample", { valueAsNumber: true })}
          error={errors.trackRecordMinSample}
          disabled={disabled}
        />
        <PolicyField
          id="policy-accuracy-high"
          label="Acurácia para confiança alta"
          unit="%"
          hint="Acima dela, a simulação exibe confiança Alta pelo histórico. Precisa ser maior que a de confiança média."
          registration={register("trackRecordAccuracyHigh", { valueAsNumber: true })}
          error={errors.trackRecordAccuracyHigh}
          disabled={disabled}
          step="0.01"
        />
        <PolicyField
          id="policy-accuracy-medium"
          label="Acurácia para confiança média"
          unit="%"
          hint="Entre ela e a anterior, a confiança exibida é Média; abaixo dela, Baixa."
          registration={register("trackRecordAccuracyMedium", { valueAsNumber: true })}
          error={errors.trackRecordAccuracyMedium}
          disabled={disabled}
          step="0.01"
        />
      </CardContent>
    </Card>
  );
}
